<div class="simple-form-aligner">
  <mat-card class="simple-form-card">
    <mat-card-header>
      <mat-card-title> Invites </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div *ngFor="let invite of invites" class="button-container">
        <p>{{ invite.orgName }}</p>
        <p>
          Invited by {{ invite.inviterName }} ({{ invite.inviterEmail }}) on
          {{ dateString(invite.createdAt) }}
        </p>

        <button
          mat-raised-button
          color="primary"
          (click)="acceptInvite(invite.orgId)"
        >
          Accept invite
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
